import { render, staticRenderFns } from "./AdminCampaignReview.vue?vue&type=template&id=34fafb78&scoped=true&"
import script from "./AdminCampaignReview.vue?vue&type=script&lang=ts&"
export * from "./AdminCampaignReview.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCampaignReview.vue?vue&type=style&index=0&id=34fafb78&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fafb78",
  null
  
)

export default component.exports